import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { SuccessDialog, ErrorDialog } from '../../../components';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { departments } from '../../../constants/volunteers';
import { SERVER_HOST, COMMENTS_ENDPOINT } from '../../../constants/endpoints';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function CommentFull(props) {
  const classes = useStyles();
  const { userID, isDeletingSuccessDialog, setDeletingSuccessDialog } = props;
  const {
    id,
    head,
    departmentID,
    creationDateByMoscow,
    comment: commentText,
  } = props.comment;
  const [isConfirmationDialog, setConfirmationDialog] = useState(false);
  const [isErrorDialog, setErrorDialog] = useState(false);
  const email = useSelector((state) => state.global?.email);

  const deleteCommentFromDB = async () => {
    try {
      await axios.delete(SERVER_HOST + COMMENTS_ENDPOINT(userID, id));
      setConfirmationDialog(false);
      return setDeletingSuccessDialog(true);
    } catch (error) {
      setDeletingSuccessDialog(false);
      return setErrorDialog(true);
    }
  };

  const isCommentAuthor =
    email === departments.find((item) => item?.id === departmentID)?.email;

  return (
    <>
      <Card
        className={classes.root}
        variant="outlined"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.02)' }}
      >
        <CardContent>
          <Box display="flex" justifyContent="space-between">
            <Box>
              <Typography variant="h6" component="h2">
                {head || '—'}
              </Typography>

              <Typography variant="body1" component="p">
                <b>Добавлен:</b> {creationDateByMoscow?.split(',')[0] || '—'}
              </Typography>

              <Typography variant="body1" component="p">
                <b>Отдел:</b>{' '}
                {departments?.find((item) => item?.id === departmentID)
                  ?.label || '—'}
              </Typography>

              <Typography variant="body1" component="p">
                <b>Текст комментария:</b> {commentText || '—'}
              </Typography>
            </Box>

            {isCommentAuthor ? (
              <Box>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  onClick={() => setConfirmationDialog(true)}
                >
                  <Box display="flex" alignContent="center">
                    <ClearIcon />
                    Удалить
                  </Box>
                </Button>
              </Box>
            ) : (
              <></>
            )}

            <Dialog
              open={isConfirmationDialog}
              onClose={() => setConfirmationDialog(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{'Уведомление'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Вы уверены, что хотите удалить оставленный комментарий? После
                  удаления руководители других Отделов не смогут его увидеть.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => setConfirmationDialog(false)}
                >
                  Отменить
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  onClick={() => deleteCommentFromDB()}
                  autoFocus
                >
                  Удалить
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </CardContent>
      </Card>

      <SuccessDialog
        isSuccessDialog={isDeletingSuccessDialog}
        setSuccessDialog={setDeletingSuccessDialog}
        description="Ваш комментарий успешно удалён!"
      />

      <ErrorDialog
        isErrorDialog={isErrorDialog}
        setErrorDialog={setErrorDialog}
      />
    </>
  );
}
